export default {"src":"/_next/static/media/purple_external_link.b32a841e.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};